import React, {useEffect, useState} from 'react'
import * as Yup from "yup";
import {useFormik} from "formik";
import {TextInput} from "../../../../components/inputs/TextInput";
import {ModeleReseauClient} from "../../../../components/Models";
import {useNavigate} from "react-router-dom";

const reseauClientSchema = Yup.object().shape({
  code: Yup.string().required("Le code est requis"),
  nom: Yup.string().required("Le nom est requis"),
})
const ReseauClientForm = (props) => {
  const navigate = useNavigate();
  const [reseauClientId, setReseauClientId] = useState(props.reseauClientId);
  const [data, setData] = useState<ModeleReseauClient>(props.data)
  const [loading, setLoading] = useState(false)

  const formik = useFormik<ModeleReseauClient>({
    initialValues: data,
    validationSchema: reseauClientSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        const updatedData = Object.assign({...data}, values)

        props.submitForm(updatedData, response => {
          formik.resetForm();
          setLoading(false);
        });
      }, 200)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-2 col-form-label required fw-bold fs-6'>Code</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'code'}
                    inputPlaceholder={'Code'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-2 col-form-label required fw-bold fs-6'>Nom</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'nom'}
                    inputPlaceholder={'Nom'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button
              type='button'
              className='btn btn-light me-3'
              disabled={loading}
              onClick={() => {
                formik.resetForm()
                navigate(`/reseau-client`)
              }}
            >
              Annuler
            </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Enregistrer'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {ReseauClientForm}
